import { render, staticRenderFns } from "./TeacherSupport.vue?vue&type=template&id=8810e69a&"
import script from "./TeacherSupport.vue?vue&type=script&lang=js&"
export * from "./TeacherSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports